import { Pipe, PipeTransform } from '@angular/core';
import { AppDateFormatService, AppDateKind } from 'src/app/@services/app-date-format.service';

/**
 * Formats dates using Settings > Date Format Setting.
 * kind: 'date' | 'datetime' | 'long' | 'longDatetime'
 *
 * Impure so templates refresh after settings load/save.
 */
@Pipe({ name: 'appDate', pure: false })
export class AppDatePipe implements PipeTransform {
  constructor(private dateFormat: AppDateFormatService) {
    this.dateFormat.ensureLoaded();
  }

  transform(value: unknown, kind: AppDateKind | string = 'datetime', empty = '—'): string {
    const normalized = this.normalizeKind(kind);
    return this.dateFormat.format(value, normalized, empty);
  }

  private normalizeKind(kind: AppDateKind | string): AppDateKind {
    switch (String(kind || '').toLowerCase()) {
      case 'date':
      case 'small':
      case 'dateonly':
        return 'date';
      case 'long':
        return 'long';
      case 'longdatetime':
      case 'longwithtime':
      case 'long_with_time':
        return 'longDatetime';
      case 'datetime':
      case 'withtime':
      case 'short':
      default:
        return 'datetime';
    }
  }
}
